import React from "react";

export default function PaymentDrawer({ data, onClose }) {
  return (
    <>
      {/* BACKDROP */}
      <div className="backdrop" onClick={onClose}></div>

      {/* DRAWER */}
      <div className="pe-drawer">
        <div className="pe-drawer-content">
          <div className="drawer-header">
            <h3>Transaction Details</h3>
            <button className="close-icon" onClick={onClose}>
              ✕
            </button>
          </div>

          <p><strong>Account:</strong> {data.accountNo}</p>
          <p><strong>IFSC:</strong> {data.ifsc}</p>
          <p><strong>VPA:</strong> {data.vpa}</p>

          <h4>Refund Attempts</h4>

          <table className="refund-table">
            <thead>
              <tr>
                <th>Attempt</th>
                <th>Status</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data.refunds.map((r, i) => (
                <tr key={i}>
                  <td>{r.attemptNo}</td>
                  <td className={r.status.toLowerCase()}>{r.status}</td>
                  <td>₹{r.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}